import React, {Component} from "react";

export class ListLoader extends Component<any, any> {

    render() {
        return (
            <div className="row list error-page">
                <div>
                    <section className="loader-holder">
                        <img className="loader" src="/images/loading.gif" alt="Be patient..."/>
                    </section>
                </div>
            </div>
        );
    }
}